import React, { useEffect } from 'react';
import $ from "jquery";
import emailjs from 'emailjs-com';

const Contact = () => {

  useEffect(() => {
    handleForm()
  }, []);


  return (
    <section className="contact" id="contact">
      <div className="alert alert-success" role="alert">
        Message sent successfully!
      </div>
      <div className="alert alert-danger" role="alert">
        Something went wrong, please try again!
      </div>
      <main>
        <div className="container">
          <div className="row justify-content-between">
            <div className="contact-text col-md-6 col-lg-5">
              <h3 className="mb-4 display-4">CONTACT</h3>
              <address>
                <section className="write-us border-botto">
                  <h3 className="h6">WRITE ME</h3>
                  <p><i>saidnasser0000@outlook.com</i></p>
                </section>
                <section className="call-us border-botto">
                  <h3 className="h6">CALL ME</h3>
                  <p><i>+201065053443</i></p>
                </section>
              </address>
              <div className="contacts d-flex justify-content-md-start justify-content-center">
                <a href="https://www.facebook.com/Yego.sns" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
                <a href="https://www.linkedin.com/in/said-nasser-595585141" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a>
                <a href="https://github.com/Said-Nasser" target="_blank" rel="noopener noreferrer"><i className="fab fa-github"></i></a>
              </div>
            </div>
            {/* <form className="contact-form col-md-6 col-lg-5" action="/send-email" method="post"> */}
            <form className="contact-form col-md-6 col-lg-5" id="contact-form" action="" method="POST">
              <div className="form-group">
                <input className="form-control rounded-0 border-0 p-3" type="text" name="name" placeholder="Name" />
              </div>
              <div className="form-group">
                <input className="form-control rounded-0 border-0 p-3" type="email" name="email" placeholder="Email" />
              </div>
              <div className="form-group">
                <input className="form-control rounded-0 border-0 p-3" type="tel" name="phone" placeholder="Phone" />
              </div>
              <div className="form-group">
                <textarea className="form-control rounded-0 border-0 p-3" rows="5" name="message" placeholder="Message"></textarea>
              </div>
              <button className="form-control border-0 rounded-0 p-3">Send</button>
            </form>
          </div>
        </div>
      </main>
    </section>
  );
}

export default Contact;


function handleForm() {

  var myform = $("form#contact-form");
  myform.submit(function (event) {
    event.preventDefault();

    var params = myform.serializeArray().reduce(function (obj, item) {
      obj[item.name] = item.value;
      return obj;
    }, {});

    // Change to your service ID, or keep using the default service
    var service_id = "default_service";
    var user_id = 'user_tk0NeMvoI5sn8SDm8qV10';
    var template_id = "template_oucmFj4Q";
    myform.find("button").text("Sending...");
    emailjs.send(service_id, template_id, params, user_id)
      .then(function () {
        $('form [name]').val('')
        $('.alert.alert-success').slideDown()
        setTimeout(() => {
          $('.alert.alert-success').slideUp()
        }, 3000);
        myform.find("button").text("Send");
      }, function (err) {
        // alert("Send email failed!\r\n Response:\n " + JSON.stringify(err));
        $('.alert.alert-danger').slideDown()
        setTimeout(() => {
          $('.alert.alert-danger').slideUp()
        }, 3000);
        myform.find("button").text("Send");
      });

    return false;
  });
}